import { isString as lo_isString } from 'es-toolkit';

export function stringOrNull(val: string | unknown): Nullable<string> {
    return lo_isString(val) && val.trim() || null;
}